<template>
  <div class="add-variant">
    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="450px">
      <v-card>
        <v-card-title>
          <span class="headline">
            Borrar plantilla de órdenes de compra
          </span>
        </v-card-title>
        <v-card-text>
          <div class="subtitle-1">
            ¿Deseas borrar la plantilla {{form.data.templateName}}?
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="close">
            Cerrar
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            @click="submit">
            Borrar plantilla
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  props: {
    template: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        data: {
          id: null,
          templateName: null
        }
      }
    }
  },
  watch: {
    template: async function (value) {
      const data = cloneDeep(value)
      this.form.data.id = data._id
      this.form.data.templateName = data.name
    }
  },
  methods: {
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    },
    closeDialog () {
      this.isOpen = false
      this.$emit('close', false)
    },
    async submit () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/purchase-templates/${this.form.data.id}`)
        this.$emit('update')
        this.closeDialog()
        this.$toasted.show('Se ha elimiando el template con éxito.', { duration: 3000 })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
      this.close()
    }
  }
}
</script>
